import { Anchor, Group, Stack, Tooltip } from '@mantine/core';
import { Badge, Icon, Text } from '@repo/foundations';
import { memo, Suspense } from 'react';
import { useSuspenseQuestion } from '../../api';
import { SlackEmbedPreviewBody } from './components/SlackEmbedPreviewBody';
import { SlackEmbedPreviewSkeleton } from './components/SlackEmbedPreviewSkeleton';
import { SlackIcon } from './components/SlackIcon';

interface SlackEmbedPreviewControllerProps {
	questionId: string;
}

function SlackEmbedPreviewControllerInternal({
	questionId,
}: SlackEmbedPreviewControllerProps) {
	const { data } = useSuspenseQuestion({
		id: questionId,
	});

	return (
		<SlackEmbedPreviewBody>
			<Group spacing="sm" noWrap w="100%">
				<SlackIcon style={{ flexShrink: 0 }} />
				<Stack spacing={0} style={{ flex: 1, minWidth: 0 }}>
					<Text size="sm" truncate weight="semibold">
						Message from{' '}
						{data.display_metadata?.owners?.[0]?.display_name ?? 'Slack'}
					</Text>
					<Text size="xs" color="text/secondary/default" lineClamp={1}>
						{data.original_slack_text ??
							data.title ??
							'could not load the message from Slack'}
					</Text>
				</Stack>
				<Group spacing="xs" noWrap>
					<Badge backgroundColor="fill/transparent-secondary/default">
						Synced
					</Badge>
					<Tooltip label="Open in Slack">
						<Anchor href={data.url} target="_blank" p="3xs">
							<Icon name="externalLink" />
						</Anchor>
					</Tooltip>
				</Group>
			</Group>
		</SlackEmbedPreviewBody>
	);
}

export const SlackEmbedPreviewController = memo(
	(props: SlackEmbedPreviewControllerProps) => (
		<Suspense fallback={<SlackEmbedPreviewSkeleton />}>
			<SlackEmbedPreviewControllerInternal {...props} />
		</Suspense>
	)
);
